import * as React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { Home } from "./screens/Home";
import { Category } from "./screens/Category";
import { Subcategory } from "./screens/Subcategory";
import { Article } from "./screens/Article";
import { BASE_PATH } from "./helpers/router.helper";
import { AppContextConsumer, IAppContext } from "./AppContext";
import { SearchResultsPage } from "./screens/SearchResults";
import { Search } from "./components/Search";

export enum Slug {
  category = "category",
  subcategory = "subcategory",
  article = "article",
}

export type UseParamsType = Record<Slug, string>;

export const Router = () => (
  <AppContextConsumer>
    {(appContext: IAppContext) => (
      <>
        <Search />
        <Routes>
          <Route path={BASE_PATH} element={<Home context={appContext} />} />
          <Route path={`${BASE_PATH}/search`} element={<SearchResultsPage />} />
          <Route
            path={`${BASE_PATH}/:${Slug.category}`}
            element={<Category context={appContext} />}
          />
          <Route
            path={`${BASE_PATH}/:${Slug.category}/:${Slug.subcategory}`}
            element={<Subcategory context={appContext} />}
          />
          <Route
            path={`${BASE_PATH}/:${Slug.category}/:${Slug.subcategory}/:${Slug.article}`}
            element={<Article context={appContext} />}
          />
          <Route path="*" element={<Navigate to={BASE_PATH} replace />} />
        </Routes>
      </>
    )}
  </AppContextConsumer>
);
